import addProperty from '../func/addProperty'
export default function Renderer (type) {
  const _type = type
  /*const animations = new LinkedList()
   let requestUpdate = false
   let node = null*/

  const canvas = document.createElement('canvas')
  addProperty(this, 'canvas', function (value) {
  }, function () {
    return canvas
  })
  const ctx = canvas.getContext('2d')
  ctx.fillStyle="#000";
  addProperty(this, 'ctx', function (value) {
  }, function () {
    return ctx
  })
  let autoResizeActiv = false
  let autoResize = null
  addProperty(this, 'autoResize', function (value) {
    autoResize = value
    if (autoResizeActiv && !autoResize) disableResize()
    if (!autoResizeActiv && autoResize) enableResize()
  }, function () {
    return autoResize
  })

  const onResize = function () {
    canvas.width = document.documentElement.clientWidth
    canvas.height = document.documentElement.clientHeight
  }
  const disableResize = function () {
    autoResizeActiv = false
    window.removeEventListener('orientationchange', onResize)
    window.removeEventListener('resize', onResize)
  }
  const enableResize = function () {
    autoResizeActiv = true
    window.addEventListener('orientationchange', onResize)
    window.addEventListener('resize', onResize)
    onResize()
  }

  this.startRender = function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  this.finishRender = function () {

  }
}